import { Identifiable, Project } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByTags(
  { tags }: Identifiable<Project>,
  { projectsTags }: Filter,
): boolean {
  return (
    !!projectsTags &&
    projectsTags.length > 0 &&
    !projectsTags.find(
      (tag) =>
        tags.length > 0 &&
        tags.find((t) => (t.name || t) === (tag.name || tag)),
    )
  );
}

export { isFilteredByTags };
